import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {TourData} from "../elements.types";
import {revealExpand} from "../../animations";

@Component({
  selector: 'as-tour',
  templateUrl: './tour.component.html',
  styleUrls: ['./tour.component.scss'],
  animations: [revealExpand]
})
export class TourComponent implements OnInit {

  @ViewChild('tourModal', {static: true}) tourModal;
  @ViewChild('tourContainer', {static: true}) tourContainer: ElementRef;
  @Input() data: TourData[];
  @Input() showDate: string;
  @Input() id: string;
  @Input() message: string = null;

  localStorageKey;
  elements;
  selectedIndex: number = 0;
  isExpired: boolean = false;
  interval;
  @Input() disclamer!: boolean;

  constructor() {
  }

  ngOnInit() {

    this.tourModal.onHide.subscribe((e) => {
      setTimeout(() => {
        this.stopInterval();
        this.moveTo(0);
      }, 1000)
    })

    this.localStorageKey = "showTour" + this.id;
    this.setup();

    if (localStorage.getItem(this.localStorageKey)) {
      this.isExpired = localStorage.getItem(this.localStorageKey) !== "true";
    }

    if (new Date(this.showDate).getTime() < new Date().getTime()) {
      this.isExpired = true;
    }
  }

  setup() {
    setTimeout(() => {
      this.elements = this.tourContainer.nativeElement
    })
  }

  moveTo(element, stop?) {
    if (stop) {
      clearInterval(this.interval)
    }
    const width = this.tourContainer.nativeElement.children[0].offsetWidth;
    this.elements.style.marginLeft = "-" + (width * element + "px");
    this.selectedIndex = element;
  }


  showModal() {
    this.tourModal.show();

    if (this.data.length > 0) {
      let currentPos = 0
      this.interval = setInterval((e) => {
        this.moveTo(currentPos);
        if ((this.data.length - 1) == currentPos) {
          currentPos = 0
        } else {
          currentPos++;
        }
      }, 5000)
    }
  }

  stopInterval() {
    clearInterval(this.interval)
  }

  dismiss() {
    localStorage.setItem(this.localStorageKey, "false");
    this.isExpired = true;
  }
}
